exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.item-content-box[data-v-6abdfd1d]{\n  padding-top: 4px;\n  line-height: 20px;\n   min-height: 20px;\n  color: #333333;\n  border-bottom: 1px solid #EEEEEE;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/auth/optlog/dialog/Detail.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,kBAAkB;GACjB,iBAAiB;EAClB,eAAe;EACf,iCAAiC;CAClC","file":"Detail.vue","sourcesContent":["\n.item-content-box[data-v-6abdfd1d]{\n  padding-top: 4px;\n  line-height: 20px;\n   min-height: 20px;\n  color: #333333;\n  border-bottom: 1px solid #EEEEEE;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6abdfd1d","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/auth/optlog/dialog/Detail.vue
// module id = p16Q
// module chunks = 0